import React, { memo } from 'react';
import cls from './WeeksModeStage.module.css';
import classNames from 'classnames';
import { WeekItemStage } from './WeekItemStage';
import { WeekModeStageChild } from './WeekModeStageChild';
import { useSelector } from 'react-redux';

export const WeeksModeStage = memo(({ stage }) => {
    const { weeks, opensStages } = useSelector((state) => state.gantReducer);
    if (!stage.positions.length) return null;

    let isPlanFactShow = true;

    if (isPlanFact) {
        isPlanFactShow = isPlanFact && !!stage.planned.start_date;
    }

    if (!isPlanFactShow) {
        return null;
    }

    return (
        <div className={classNames(cls.DaysModeStage)}>
            <div className={classNames(cls.weeks)}>
                {weeks.map((month) => (
                    <div className={classNames(cls.weeks)} key={Math.random().toString(36)}>
                        {month.weeks.map((item) => (
                            <WeekItemStage
                                week={item}
                                isPlanFact={isPlanFact}
                                stage={stage}
                                key={Math.random().toString(36)}
                            />
                        ))}
                    </div>
                ))}
            </div>
            {opensStages[stage.id] && (
                <>
                    {stage.positions.map((childGuid) => (
                        <WeekModeStageChild
                            key={Math.random().toString(36) + childGuid}
                            childGuid={childGuid}
                        />
                    ))}
                </>
            )}
        </div>
    );
});
